import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SkypeOutlinedSvg from "@ant-design/icons-svg/es/asn/SkypeOutlined";
import AntdIcon from "../components/AntdIcon";
var SkypeOutlined = function SkypeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SkypeOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SkypeOutlined.displayName = 'SkypeOutlined';
}
export default /*#__PURE__*/React.forwardRef(SkypeOutlined);